import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomFormControl } from '../../../../classes/custom-form-control.class';
import { passwordValidator } from '../../../../validators/password.validator';
import { forbiddenInputsValidator } from '../../../../validators/forbidden-inputs.validator';

@Component({
  selector: 'mono-common-password-input',
  templateUrl: './password-input.component.html',
})
export class PasswordInputComponent extends CustomFormControl {

  @Input() forbiddenPasswords?: string[] = [];

  constructor() {
    super();
  }

  protected createFormControl(): FormControl {
    return new FormControl('', [
      Validators.required,
      Validators.minLength(12),
      Validators.maxLength(99),
      passwordValidator,
      forbiddenInputsValidator(this.forbiddenPasswords)
    ]);
  }

}